import { OrganizationProvider } from '../interfaces/Organization';

export const createDefaultOrganizationProvider = (
  organizationId: number | null,
  providerCategoryId: number,
  paymentMethodId: number,
  paymentDays: number,
  partnerId: number | null = null
): OrganizationProvider => ({
  id: 0,
  organizationId,
  providerCategoryId,
  name: '',
  companyNumber: null,
  address: null,
  contactName: null,
  contactPhone: null,
  contactEmail: null,
  website: null,
  countryId: null,
  regionId: null,
  cityId: null,
  leaseProviderCategoryId: null,
  paymentMethodId,
  paymentDays,
  paymentMethod: null,
  providerCategory: null,
  country: null,
  region: null,
  city: null,
  partnerId,
  partner: null
});
